const allowlistedURIs = [
  'www.youtube.com',
  'player.vimeo.com',
  'fast.wistia.net',
  'embed.ted.com',
  'cdnapisec.kaltura.com',
  'media.hartfordhealthcare.org',
  'play.vidyard.com',
  'players.brightcove.net',
  'www.brainshark.com',
];

const allowedIframeAttributes = [
  'src',
  'width',
  'height',
  'frameborder',
  'allow',
  'allowfullscreen',
  'webkitallowfullscreen',
  'mozallowfullscreen',
  'allowtransparency',
  'scrolling',
  'class',
];

// Rebuilds the iframe from scratch with only allowlisted attributes —
// returning the pasted node's outerHTML would preserve handlers like
// onload= or a srcdoc= payload.
export const sanitizeIframe = inputValue => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(inputValue, 'text/html');
  const iframe = doc.querySelector('iframe');

  if (!iframe) return false;

  const anchor = document.createElement('a');
  anchor.href = iframe.getAttribute('src') || '';

  const allowedSource =
    ['http:', 'https:'].includes(anchor.protocol) &&
    allowlistedURIs.includes(anchor.hostname);

  if (!allowedSource) return false;

  const clean = document.createElement('iframe');
  allowedIframeAttributes.forEach(attribute => {
    const attributeValue = iframe.getAttribute(attribute);
    if (attributeValue !== null) clean.setAttribute(attribute, attributeValue);
  });

  return clean.outerHTML;
};
